import { application } from "./application"

import AutosubmitController from "./autosubmit_controller"
import ClipboardController from "./clipboard_controller"
import CurrencyInputController from "./currency_input_controller"
import DirectUploadController from "./direct_upload_controller"
import DropdownController from "./dropdown_controller"
import FlashController from "./flash_controller"
import ModalController from "./modal_controller"
import PinInputController from "./pin_input_controller"
import SidebarController from "./sidebar_controller"
import SortableController from "./sortable_controller"
import CompositionPreviewController from "./composition_preview_controller"

application.register("autosubmit", AutosubmitController)
application.register("clipboard", ClipboardController)
application.register("currency-input", CurrencyInputController)
application.register("direct-upload", DirectUploadController)
application.register("dropdown", DropdownController)
application.register("flash", FlashController)
application.register("modal", ModalController)
application.register("pin-input", PinInputController)
application.register("sidebar", SidebarController)
application.register("sortable", SortableController)
application.register("composition-preview", CompositionPreviewController)
